
const state = {
    recipe: null,    
    recipeInfoList: [],
    closedRecipeInfoList: []
};

export default state;
